"use client";

import React from "react";
import Image from "next/image";
import styles from "./DevelopmentSupportMaintenanceSection.module.css";
import { developmentSupportMaintenanceData } from "../../data/development-support";

export default function DevelopmentSupportMaintenanceSection() {
  return (
    <section
      className={styles.section}
      aria-label="Support and Maintenance Development Services"
    >
      <div className="container">
        <div className={styles.header}>
          <span className={styles.eyebrow}>
            Multi-tier software support services
          </span>
          <h2 className={styles.title}>
            Support and Maintenance Development Services
          </h2>
          <p className={styles.desc}>
            If you&apos;re looking to extend the lifecycle of your software
            while keeping it aligned with your evolving business goals, having a
            dependable IT maintenance and support service is essential. Below
            are the key services we offer to help you achieve just that.
          </p>
        </div>

        <div className={styles.grid}>
          {developmentSupportMaintenanceData.map((item, idx) => (
            <article key={idx} className={styles.item}>
              <div className={styles.itemHeader}>
                <span className={styles.dot} aria-hidden="true" />
                <h3 className={styles.itemTitle}>{item.title}</h3>
              </div>
              <p className={styles.itemDesc}>{item.description}</p>
              {item.image && (
                <div className={styles.thumbWrap}>
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                    className={styles.thumb}
                    sizes="(max-width: 560px) 100vw, (max-width: 992px) 50vw, 33vw"
                    priority={false}
                  />
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
